import React, { Component } from 'react';
import { connect } from 'react-redux';
import { emailLogin } from '../actions/userAction';
import styled from 'styled-components';
import TextField from "material-ui/TextField";

var firebase = require('firebase');

const Background = styled.div`
  background: #fff;
  position: fixed;
  top:0;
  left:0;
  bottom:0;
  right:0;
`;

const Button = styled.button`
  padding: 0.25em 1em;
  margin: 0;
  margin-top:30px;
  background: #20323f;
  color: #fff;
  border: 0
  width:100%;
  font-size: 12px;
  padding: 15px;
  border-radius:5px !important;
`;

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  email: '',
  password: '',
  error: null,
};

class Login extends Component {
    constructor(props) {
        super(props);
        //this.login = this.login.bind(this);
        this.state = { ...INITIAL_STATE };

    }

    componentWillMount() {
        if (this.props.user !== null) {
            // console.log(this.props.history);
            this.props.history.push('/');
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user !== null) {
            nextProps.history.push('/');
        }
    }

    onSubmit = (event) => {

        const {
          email,
          password,
        } = this.state;

        const {
          history,
        } = this.props;

        firebase.auth().signInWithEmailAndPassword(email, password)
          .then(() => {
            this.setState(() => ({ ...INITIAL_STATE }));
            history.push('/');
          })
          .catch(error => {
            console.log("Err: " + JSON.stringify(error))
            this.setState(byPropKey('error', error));
          });

        event.preventDefault();
      }


    render() {
        const {
          email,
          password,
          error,
        } = this.state;

        const isInvalid =
          password === '' ||
          email === '';

        return (
            <Background>
                <div className="container-fullwidth">
                    <nav className="navbar bg-white">
                        <div className="container-fluid navbar-brand text-center">
                            <img src="/telescope.png" className="logo" alt="Telescope"/>
                        </div>
                    </nav>


                    <div className="text-center vertical-center">
                        <div className="col-sm-4 center-block" style={{ marginTop: '-20px' }}>
                            <h2>
                                Login
                            </h2>
                             <form onSubmit={this.onSubmit}>
                              <TextField
                                value={email}
                                floatingLabelText="Email"
                                onChange={event => this.setState(byPropKey('email', event.target.value))}
                                type="text"
                                style={{width:'100%'}}
                              /><br/>
                              <TextField
                                value={password}
                                floatingLabelText="Password"
                                onChange={event => this.setState(byPropKey('password', event.target.value))}
                                type="password"
                                style={{width:'100%'}}
                              /><br/>
                              <Button disabled={isInvalid} type="submit">
                                LOGIN
                              </Button>

                              { error && <p>{error.message}</p> }
                            </form>


                          {/*<Button onClick={this.props.googleLogin}>
                                Login with Google
                            </Button>*/}
                        </div>
                    </div>

                </div>
            </Background>
        );
    }
}

function mapStateToProps(state, onwProps) {
    return {
        user: state.user
    };
}

export default connect(mapStateToProps, { emailLogin /* googleLogin, twitterLogin */})(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js